/* globals GLOBAL */
import { Platform, Linking } from 'react-native'
import { startNetworkLogging } from 'react-native-network-logger'
import moment from 'moment'
import { logger } from 'APP/Lib/Datadog'

import i18n from 'APP/I18n'
import Analytics from 'APP/Services/Analytics'
import Config from 'APP/Config'
import { initInsider } from 'APP/Services/Insider'
import { initDatadogRUM } from 'APP/Lib/Datadog'
import { isHeadlessTask } from 'APP/Lib/HeadlessTask'
import RNCallKeep from 'react-native-callkeep'
import { getBrandConfig } from 'APP/Lib/ConfigHelpers'
import { initialize as initializeNativeCall } from 'APP/NativeModules/NativeCall'
import { isWeb } from 'APP/Helpers/checkPlatform'
import { TrackUtmParamsType } from 'APP/Services/Analytics'

// This initializes a HeadlessTask and must be called during JS initialization.
initializeNativeCall()

declare global {
  let GLOBAL: {
    XMLHttpRequest: any // eslint-disable-line @typescript-eslint/no-explicit-any
    originalXMLHttpRequest?: any // eslint-disable-line @typescript-eslint/no-explicit-any
  }
}

export const getEnvTag = (): string => {
  return Config.PROD ? 'production' : 'development'
}

const tryGetInitialURL = async (): Promise<string | null> => {
  try {
    return await Linking.getInitialURL()
  } catch (err) {
    logger.error('Failed to get initial URL', {}, err)
    return null
  }
}

export const initAnalytics = async () => {
  Analytics.init()
  if (isWeb()) {
    await Analytics.trackUtmParameters({
      type: TrackUtmParamsType.URL,
      args: {
        url: isHeadlessTask() ? null : await tryGetInitialURL(),
      },
    })
  }
  Config.onConfigKeyChange('SNOWPLOW', (done) => {
    Analytics.init()
    done()
  })
}

export const initRNCallKeep = (): void => {
  if (Platform.OS === 'ios') {
    RNCallKeep.setup({
      ios: {
        appName: getBrandConfig(Config.BRAND_ID, i18n.baseLocale).productName,
        imageName: 'chat_icon_black_fill',
        // @ts-expect-error the package definitely supports this argument, even though their type is missing it.
        handleType: 'generic',
      },
    })
  }
}

// Make sure that this only runs once.
let initPromise: Promise<void> | null = null

export const initConfig = () => {
  if (initPromise != null) {
    return initPromise
  }

  initPromise = (async () => {
    await Config.init()
    await initDatadogRUM()
    moment.locale(i18n.baseLocale)
    await initAnalytics()
    initRNCallKeep()
    initInsider()
  })()

  return initPromise
}

type JSONPrimitive = string | number | boolean | null | undefined

type JSONValue =
  | JSONPrimitive
  | JSONValue[]
  | {
      [key: string]: JSONValue
    }

type BeforeSendEvent = {
  message?: string
  [key: string]: JSONValue
}

export const beforeSendFn = (event: BeforeSendEvent): BeforeSendEvent | null => {
  if (event.message?.startsWith('NetworkError')) {
    return null
  }
  return event
}

export const initNetworkLogging = (): void => {
  // Note: This will enforce security headers, and may break things.
  const ROUTE_REQUESTS_THROUGH_CHROME_DEBUGGER = false
  if (__DEV__) {
    if (ROUTE_REQUESTS_THROUGH_CHROME_DEBUGGER) {
      GLOBAL.XMLHttpRequest = GLOBAL.originalXMLHttpRequest || GLOBAL.XMLHttpRequest
    }
    startNetworkLogging({ ignoredHosts: ['localhost'] })
  }
}
